import { Modal } from 'antd';

export default function ProfileMenuModal({ visible, toggleVisibility, title, content }) {
  return (
    <Modal open={visible} onCancel={toggleVisibility} title={title} footer={null} centered>
      {content()}
    </Modal>
  );
}
